module.exports = __webpack_public_path__ + "media/images/city/092-leaning-tower-of-nevyansk-ebcc42b2cda83d27fcf29db322b6a40c.svg";